<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/components/Coords'

    export default {
        components: {
            Grid,
        }
    }
</script>